import {reactive} from "vue";
import useVuelidate from "@vuelidate/core";

export const useForm = ({props, rules}) => {
    const form = reactive(typeof props === "object" ? props : props());

    const validator = useVuelidate(typeof rules === "object" ? rules : rules(), form);

    return {
        form,
        v$: validator,
        validate: () => validator.$validate()
    };
}